module.exports = __webpack_public_path__ + "static/media/dislike-button.cb92b403.svg";